// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","masterCreateStudyPage":"master-create-study-page_masterCreateStudyPage__vzA7D"};